import React from 'react';
import { BrandDetailsProps } from './brand-details-type';

import styles from './brand-details-component.module.css';

export const BrandDetails: React.FC<BrandDetailsProps> = React.memo(
    ({ name, description, asset }: BrandDetailsProps) => {
        if (!description && !asset) {
            return <React.Fragment></React.Fragment>;
        }
        return (
            <div className={styles.detailsContainer}>
                {description && (
                    <div className={styles.descriptionContainer}>
                        <div className={styles.detailsTitle}>{name}</div>
                    </div>
                )}
            </div>
        );
    },
);
